// todo - these should not be in the generic components layer
// there should be a config and these passed in

export const CLOUDINARY_API_KEY = '426863927861121';
export const CLOUDINARY_CLOUD_NAME = 'homeroom-com';
export const CLOUDINARY_URL_BASE = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/`;
export const WEBSERVER_IMAGE_ROOT = '/assets';
